import { ApolloLink } from '@apollo/client';
import { uploadXHR } from './upload-xhr';

export async function uploadFile<TAdd, TConfirm>(
  file: File,
  getUploadUrl: (file: File) => Promise<ApolloLink.Result<TAdd>>,
  getUploadUrlFromAddResult: (addData: TAdd) => string,
  confirmUpload: (file: File, addData: TAdd) => Promise<ApolloLink.Result<TConfirm>>,
  headers?: Record<string, string>,
) {
  // get upload URL
  const getUploadUrlResult = await getUploadUrl(file);

  let uploadUrl: string;
  if (getUploadUrlResult.data) {
    uploadUrl = getUploadUrlFromAddResult(getUploadUrlResult.data);
  } else {
    throw Error('Error getting upload URL');
  }

  // upload
  let uploadStatus: number;
  try {
    uploadStatus = await uploadXHR(file, uploadUrl, { onError: (e) => console.error('Upload error:', e) }, headers);
  } catch (e) {
    throw Error(`Error during upload: ${e}`);
  }

  if (uploadStatus != 200) {
    throw Error(`Upload failed with status ${uploadStatus}`);
  }

  try {
    // confirm upload
    const confirmUploadResult = await confirmUpload(file, getUploadUrlResult.data);

    if (confirmUploadResult.errors) {
      throw Error('Error during upload confirmation');
    }
    return confirmUploadResult;
  } catch (e) {
    throw Error(`Error confirming upload: ${e}`);
  }
}
